import { Component, OnInit, Input } from '@angular/core';
import { ModalController, IonInfiniteScroll, Platform } from '@ionic/angular';
import { CommunicationRecordsPage } from '../communication-records/communication-records.page'
import { PotentialMembersdetailPage } from '../potential-membersdetail/potential-membersdetail.page'
import { HttpCustomerService, MessageclientService, NativeService } from 'src/service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from 'src/service/common.service';
import { BaseCase } from 'src/app/basecase';
import { BaseModal } from 'src/model';
import { WebParameterContext } from 'src/model/common';
import { GridBaseCase } from '../../grid/grid.base.case';
import { PotentialMemberslistPage } from '../potential-memberslist/potential-memberslist.page';
import { SearchModalPage } from "src/app/components/nestle-crm/content-library/search-modal/search-modal.page";
declare var app;
@Component({
  selector: 'app-content-library-details',
  templateUrl: './content-library-details.component.html',
  styleUrls: ['./content-library-details.component.scss']
})
export class ContentLibraryDetailsComponent extends GridBaseCase {
  contentLibery: boolean = false;
  tabindex: number = 1;
  dataArrayList1: Array<any> = [];
  dataArrayList2: Array<any> = [];
  dataArrayList3: Array<any> = [];
  allDataList: Array<any> = [];
  fiCationID: any; // 页面传的标签id
  fatherNodeSelect: number = 0;//父节点选中状态 用于显示样式
  nodeLevel:number=1;//1级节点  1  2级节点  2  3级节点 3
  searchValue:string="";//搜索名称
  constructor(
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
    private native: NativeService,
    public baseService: BaseCase,
    public base: BaseModal,
    private route: ActivatedRoute,
    public modal: ModalController
  ) {
    super();
    // this.activaRouter.queryParams.subscribe(queryParams => {
    //   this.fiCationID = queryParams.fiCationID; // 页面传的标签id
    // });
    this.fiCationID = this.route.snapshot.queryParamMap.get("fiCationID");
    if(this.route.snapshot.queryParamMap.get("nodeLevel"))
    {
      this.nodeLevel = parseInt(this.route.snapshot.queryParamMap.get("nodeLevel"));
    }
    console.log(this.fiCationID);
  }

  ngOnInit() {
    this.loadData();
  }

  searchEvent(evev:any,e:any)
  {
    this.loadData();
  }
  async openSearchModel() {
    // this.isShowSearchModel = true;
    const modal = await this.modal.create({
      component: SearchModalPage,
      componentProps: {
        "type": "Home",
      }
    });
    await modal.present();
    const { data } = await modal.onWillDismiss();
  }
  loadData() {
    var that = this;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;

    body.ConfigName = "NumberOfRticles";
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = 1000;

    body.PageNumber = 1;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    let typeObj = {};
    //ExamineState  1 审批通过  2 审批拒绝  3 待审批   4 无需审批
    // typeObj["Mobile"] = "17805685158";
    if(that.fiCationID)
    {
      if(that.nodeLevel==1)
      {
        typeObj["LevelOneID"] = that.fiCationID;
      }else  if(that.nodeLevel==2)
      {
        typeObj["LevelTwoID"] = that.fiCationID;
      }else{
        typeObj["LevelThereID"] = that.fiCationID;
      }
      if(that.searchValue){
        typeObj["Name"] = that.searchValue;
      }
    }else{
      typeObj["Name"] = that.searchValue;
    }
    body.RequestBody = JSON.stringify(typeObj);
    that.http.post(app.DEFAULTURL, body).then(data => {

      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
        //非详情  不根据id查询
        that.dataArrayList1 = [];
        that.dataArrayList2 = [];
        that.dataArrayList3 = [];
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
        if(!that.fiCationID)
        {
        that.allDataList = data.Status.Datas;
        that.dataArrayList1 = data.Status.Datas.filter(n => n.Level == "1");
        that.dataArrayList2 = data.Status.Datas.filter(n => n.Level == "2");
        that.dataArrayList3 = data.Status.Datas.filter(n => n.Level == "3");

        that.dataArrayList3.forEach(it => {
          it["Show"] = false;
        });
        that.dataArrayList1.forEach(it => {
          it["Show"] = false;
          it["secondNode"] = that.dataArrayList2.filter(n => n.FK_Parent_ID == it.ID)
        });
        if (that.dataArrayList1 && that.dataArrayList1.length > 0) {
          that.dataArrayList1[0]["Show"] = true;
        }
        if (that.dataArrayList2 && that.dataArrayList2.length > 0) {
          that.dataArrayList2[0]["Show"] = true;
          let first_id = that.dataArrayList1[0]["ID"] || "";
          that.dataArrayList2 = data.Status.Datas.filter(n => n.Level == "2" && n.FK_Parent_ID == first_id);
          that.dataArrayList2.forEach(it => {
            it["Show"] = false;
            it["threeNode"] = that.dataArrayList3.filter(n => n.FK_Parent_ID == it.ID)
          });
        }
        that.fatherNodeSelect = 0;
      }else{
        //根据id查询
        that.allDataList = data.Status.Datas;
         
        that.dataArrayList1 = data.Status.Datas.filter(n => n.Level == "1");
        that.dataArrayList2 = data.Status.Datas.filter(n => n.Level == "2");
        that.dataArrayList3 = data.Status.Datas.filter(n => n.Level == "3");

        that.dataArrayList3.forEach(it => {
          it["Show"] = false;
        });
        that.dataArrayList1.forEach(it => {
          it["Show"] = false;
          it["secondNode"] = that.dataArrayList2.filter(n => n.FK_Parent_ID == it.ID)
        });
        if (that.dataArrayList1 && that.dataArrayList1.length > 0) {
          that.dataArrayList1[0]["Show"] = true;
        }
        if (that.dataArrayList2 && that.dataArrayList2.length > 0) {
          that.dataArrayList2[0]["Show"] = true;
          let first_id = that.dataArrayList1[0]["ID"] || "";
          that.dataArrayList2 = data.Status.Datas.filter(n => n.Level == "2" && n.FK_Parent_ID == first_id);
          that.dataArrayList2.forEach(it => {
            it["Show"] = false;
            if(that.nodeLevel==3)
            {
              it["Show"] = true;
            }
            it["threeNode"] = that.dataArrayList3.filter(n => n.FK_Parent_ID == it.ID)
          });
        }
        that.fatherNodeSelect = 0;
      }
        console.log(that.dataArrayList1, "dataArrayList");
        console.log(that.dataArrayList2, "dataArrayList");
      }

    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      // console.log(error);
    });
  }
  listShowsee(item, i) {
    const that = this;
    // item.contentLibery = true;
    that.contentLibery = !that.contentLibery;
    let current_id = item.ID || "";
    that.dataArrayList2.forEach(it => {
      if (it.ID == item.ID) {
        it["Show"] = !it["Show"];
      }
      // it["threeNode"] = that.allDataList.filter(n => n.Level == "3" && n.FK_Parent_ID == current_id);
    });
  }
  // listShowhide(item, i) {
  //   const that = this;
  //   // item.contentLibery = false;
  //   that.contentLibery = false;
  // }
  tabEven(item, num) {
    const that = this;
    that.tabindex = num;
    let current_id = item.ID || "";
    that.dataArrayList2 = that.allDataList.filter(n => n.Level == "2" && n.FK_Parent_ID == current_id);
    that.dataArrayList2.forEach(it => {
      it["Show"] = false;
      it["threeNode"] = that.dataArrayList3.filter(n => n.FK_Parent_ID == it.ID)
    });
    that.fatherNodeSelect = num;
  }
   /**
   * 
   * @param e 跳转页面
   */
  EvrntDetail(item, i) {
    const that = this;
    console.log(item.ID,"显示得iddddddddddd");
    that.com.setHistoryUrl(true);
    that.com.Go("/tabs/contact/ContentLibraryList/" + this.com.getNowDatetime,{
      a_ID:item.ID,
      name:item.Name,
      LevelThereID:item.FK_Parent_ID,
      searchValue:item.Name,
      type:6// 1 代表点击搜索列表跳详情 2 代表我的收藏列表跳详情， 3代表浏览历史列表跳详情页 6代表内容分类跳转列表页
    });
  }
}
